var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('el-image-viewer',{attrs:{"url-list":_vm.list,"on-close":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }